import { useEffect, useState } from 'react';
import Field from '../shared/field';

export type ExamTimerPropsType = {
  remainSeconds: number;
  onFinish: () => void;
};

function ExamTimer({ remainSeconds, onFinish }: ExamTimerPropsType) {
  const [seconds, setSeconds] = useState<number>(remainSeconds);

  useEffect(() => {
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);

  const tick = () => {
    if (seconds > 0) {
      setSeconds(seconds => seconds - 1);
    } else {
      onFinish();
      setSeconds(0);
    }
  };

  const getTime = () => new Date(seconds * 1000).toISOString().slice(11, 19);

  return <Field title='زمان باقی مانده' content={getTime()} />;
}

export default ExamTimer;
